import './DesktopFrame.css'

import React, { CSSProperties } from 'react'
import clsx from 'clsx'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useBreakpoint } from '@/hooks/useBreakpoint'
import { MAKYO_APP_DOMAIN } from '@/shared/constants'

import BrowserFrame from './BrowserFrameDemo'

type DesktopFrameProps = {
  scale: number
  bgColor?: string
  statusBarColor: string | number
  children: React.ReactNode
  withSearch?: boolean
  isFullScreen?: boolean
  deviceRef: React.RefObject<HTMLDivElement>
}

/**
 * @todo - still work in progress
 */
export const DesktopFrame = ({
  scale,
  bgColor,
  statusBarColor,
  withSearch,
  children,
  isFullScreen,
  deviceRef,
}: DesktopFrameProps) => {
  const { isDesktop, isNavigationBarBottom } = useBreakpoint()
  const { project } = useAppBuilderContext()

  const projectAppUrl = project?.href || ''
  const url = `https://${projectAppUrl}.${MAKYO_APP_DOMAIN}`

  const segmentUrl = window.location.href.includes('app/') ? window.location.href.split('app/').pop() : ''
  return (
    <div className={clsx(isFullScreen ? 'w-full h-full' : 'mk-frame mk-frame-desktop')}>
      <div className={clsx(isFullScreen ? 'w-full h-full' : 'device-frame-desktop')}>
        <div
          className={clsx(isFullScreen ? 'w-full h-full' : 'device-screen-desktop')}
          style={
            {
              background: `var(--color-${bgColor})`,
            } as CSSProperties
          }
        >
          {isDesktop && !isFullScreen && <BrowserFrame url={`${url}/${segmentUrl}`} />}
          <div
            className={clsx('device-viewport-desktop', withSearch && 'search-bar')}
            style={
              {
                position: 'relative',
                height: isDesktop && !isNavigationBarBottom && !isFullScreen ? 'calc(100% - 80px)' : '100%',
              } as CSSProperties
            }
            ref={deviceRef}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
